/**
 * Routes add breadcrumb segments after their nav item through `staticData.crumbs`, e.g. the
 * currency code on `/currencies/$code`. The last segment is the page title.
 */
export interface Crumb {
  label: string;
  /** Link target for every segment but the last. */
  href?: string;
}

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /** `loaderData` is what the route's loader returned (usually the entity), so crumbs can name it. */
    crumbs?: (params: Record<string, string>, loaderData: unknown) => Crumb[];
  }
}

/** The first non-empty string field of `data` among `keys`, e.g. `labelFrom(game, 'Name')`. */
export function labelFrom(data: unknown, ...keys: string[]): string | undefined {
  if (!data || typeof data !== 'object') return undefined;
  for (const key of keys) {
    const value = (data as Record<string, unknown>)[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return undefined;
}
